import * as Feature from "./featureStyles";

export default function FeatureContainer() {
  return (
    <Feature.Container src="homeheader">
    </Feature.Container>
  );
}
